import { Term } from 'services/terms-and-conditions/types'

const createUsBranchTerms = (): Term[] => [
  {
    key: 'inter-us-branch-electronic-communications-and-debit-card-agreement',
    id: 'inter-us-branch-electronic-communications-and-debit-card-agreement',
    title: 'Eletronic Communications and Debit Card Agreement',
    description: '',
    url: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/globalAccount/termos/termos-webview/us/Contrato_de_Comunicac%CC%A7o%CC%83es_Eletro%CC%82nicas_e_Assinaturas_-_EN_-.pdf',
  },
  {
    key: 'inter-us-branch-account-and-debit-card-agreement',
    id: 'inter-us-branch-account-and-debit-card-agreement',
    title: 'Inter U.S. Branch Account and Debit Card Agreement',
    description: '',
    url: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/globalAccount/termos/termos-webview/us/Contrato_de_Conta_e_Carta%CC%83o_de_De%CC%81bito_do_Inter_US_Branch_-_EN_-__1_.pdf',
  },
  {
    key: 'inter-us-branch-privacy-notice',
    id: 'inter-us-branch-privacy-notice',
    title: 'Privacy Notice',
    description: '',
    url: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/globalAccount/termos/termos-webview/us/Aviso_de_Privacidade_-_EN_-_.pdf',
  },
  {
    key: 'inter-us-branch-privacy-policy',
    id: 'inter-us-branch-privacy-policy',
    title: 'Inter U.S. Branch Privacy Policy',
    description: '',
    url: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/globalAccount/termos/termos-webview/us/Privacy+Portal.pdf',
  },
  {
    key: 'inter-us-branch-fee-schedule',
    id: 'inter-us-branch-fee-schedule',
    title: 'Fee Schedule',
    description: '',
    url: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/globalAccount/termos/termos-webview/us/Tabela_de_Tarifas_-_EN_-_PDF.pdf',
  },
  {
    key: 'inter-us-branch-user-agreement',
    id: 'inter-us-branch-user-agreement',
    title: 'User Agreement',
    description: '',
    url: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/globalAccount/termos/termos-webview/us/Contrato_de_Usua%CC%81rio_-_EN_-_PDF__1_.pdf',
  },
]

const terms: Record<string, Term[]> = {
  'pt-BR': createUsBranchTerms(),
  'en-US': createUsBranchTerms(),
  'es-ES': createUsBranchTerms(),
}

export default terms
